module.exports = __webpack_public_path__ + "img/logo-bramfeld-large.f9d6c77d.png";